import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';

import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const UsersTable = props => {
  const { className, users, selectUser, ...rest } = props;

  const classes = useStyles();

  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleSelectAll = event => {
    const { users } = props;

    let selectedUsers;

    if (event.target.checked) {
      selectedUsers = users.map(user => user.id);
    } else {
      selectedUsers = [];
    }

    setSelectedUsers(selectedUsers);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedUsers.indexOf(id);
    let newSelectedUsers = [];

    if (selectedIndex === -1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers, id);
    } else if (selectedIndex === 0) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(1));
    } else if (selectedIndex === selectedUsers.length - 1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedUsers = newSelectedUsers.concat(
        selectedUsers.slice(0, selectedIndex),
        selectedUsers.slice(selectedIndex + 1)
      );
    }
    setSelectedUsers(newSelectedUsers);
    selectUser(newSelectedUsers);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedUsers.length === users.length}
                      color="primary"
                      indeterminate={
                        selectedUsers.length > 0 &&
                        selectedUsers.length < users.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>用户名</TableCell>
                  <TableCell>姓名</TableCell>
                  <TableCell>邮箱</TableCell>
                  <TableCell>地区</TableCell>
                  <TableCell>电话</TableCell>
                  <TableCell>最近访问时间</TableCell>
                  <TableCell>最近登录地点</TableCell>
                  <TableCell>报价表</TableCell>
                  <TableCell>订单列表</TableCell>
                  <TableCell>编辑</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map(user => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={user.id}
                    selected={selectedUsers.indexOf(user.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedUsers.indexOf(user.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, user.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {
                          user.userInfo && user.userInfo.avatar
                            ? (
                                <Avatar
                                  className={classes.avatar}
                                  src={user.userInfo.avatar}
                                >
                                  {getInitials(user.userInfo ? `${user.userInfo.firstname} ${user.userInfo.lastname}` : '')}
                                </Avatar>
                              )
                            : (
                              <Avatar
                                className={classes.avatar}
                                src={user.avatarUrl}
                              >
                                {getInitials(user.userInfo ? `${user.userInfo.firstname} ${user.userInfo.lastname}` : '')}
                              </Avatar>
                            )
                        }
                        <Typography variant="body1">{user.userName}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{user.userInfo ? `${user.userInfo.firstname} ${user.userInfo.lastname}` : ''}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      {user.userInfo ? `${user.userInfo.country},${user.userInfo.state}` : ''}
                    </TableCell>
                    <TableCell>{user.userInfo ? user.userInfo.mobile : ''}</TableCell>
                    <TableCell>
                      {moment(user.lastLoginTime).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell>
                      {user.lastLoginAddress || '未知'}
                    </TableCell>
                    <TableCell>
                      <Link to={`/quotation/${user.id}`}>立即查看</Link>
                    </TableCell>
                    <TableCell>
                      <Link to={`/user/${user.id}/orders`}>立即查看</Link>
                    </TableCell>
                    <TableCell>
                      <Link to={`/user/${user.id}`}>编辑</Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

UsersTable.propTypes = {
  className: PropTypes.string,
  users: PropTypes.array.isRequired,
};

export default UsersTable;
